import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CategoryResolverService } from '../../Services/category-resolver.service';
import { HomeBannersResolverService } from '../../Services/home-banners-resolver.service';
import { MainResolverService } from '../../Services/main-resolver.service';
import { NewsResolverService } from '../../Services/news-resolver.service';
import { HomeComponent } from './home.component';
import { SelectedForYouResolverService } from '../../Services/selected-foryou-resolver.service';
import { HomeLastaddedResolverService } from '../../Services/home-lastadded-reslover.service';
import { LastActionsResolverService } from '../../Services/last-actions-resolver.service';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    resolve: {
      lastNews: NewsResolverService,
      categories: CategoryResolverService,
      recommendedBanners: MainResolverService,
      homeBanners: HomeBannersResolverService,
      homeSelectedForYou: SelectedForYouResolverService,
      homeLastAdded: HomeLastaddedResolverService,
      lastActions: LastActionsResolverService
    }
  },
  {
    path: 'en',
    component: HomeComponent,
    resolve: {
      lastNews: NewsResolverService,
      categories: CategoryResolverService,
      recommendedBanners: MainResolverService,
      homeBanners: HomeBannersResolverService,
      homeSelectedForYou: SelectedForYouResolverService,
      homeLastAdded: HomeLastaddedResolverService,
      lastActions: LastActionsResolverService
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
